module.exports = __webpack_public_path__ + "static/media/ic_device_green.4621a019.svg";